import apiV2 from '../api/v2';
import { toApiError } from './apiErrors';

// Accounts > Orthodontist detail > Details > Feature settings, backed by
// /api/v2/orthodontist/feature-flags - the parallel of practiceFeatureFlags.ts.

export interface OrthodontistFeatureFlag {
    key: string;
    title: string;
    description: string;
    enabled: boolean;
    enabledAt: string | null;
}

export async function fetchOrthodontistFeatureFlags(
    orthodontistId: string
): Promise<OrthodontistFeatureFlag[]> {
    try {
        const response = await apiV2.get<{ success: boolean; data: OrthodontistFeatureFlag[] }>(
            `/orthodontist/feature-flags/${orthodontistId}`
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}

/** Upserts the row - `enabled: true` adds/re-enables it, `enabled: false` disables it. */
export async function toggleOrthodontistFeatureFlag(
    orthodontistId: string,
    feature: string,
    enabled: boolean
): Promise<void> {
    try {
        await apiV2.put(`/orthodontist/feature-flags/${orthodontistId}`, { feature, enabled });
    } catch (err) {
        throw toApiError(err);
    }
}
